import { render, staticRenderFns } from "./modify-wrapper.vue?vue&type=template&id=5a6ba19d&scoped=true&"
import script from "./modify-wrapper.vue?vue&type=script&lang=js&"
export * from "./modify-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./modify-wrapper.vue?vue&type=style&index=0&id=5a6ba19d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ba19d",
  null
  
)

export default component.exports